import { render, staticRenderFns } from "./StoreHomePage.vue?vue&type=template&id=5f60f97a&scoped=true"
import script from "./StoreHomePage.vue?vue&type=script&lang=ts"
export * from "./StoreHomePage.vue?vue&type=script&lang=ts"
import style0 from "./StoreHomePage.vue?vue&type=style&index=0&id=5f60f97a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f60f97a",
  null
  
)

export default component.exports